export const numberToCurrency = (value: number): string => 
    value % 1 !== 0 ? (Math.round(value * 100) / 100).toFixed(2) : value.toString()
